@if (authService.user) {
  <div
    class="authenticated-user"
    oc-dropdown
    [ocDropdownMenu]="userMenu"
  >
    <div class="flex col items-end">
      <h5 data-testid="topbar-user-name">{{ authService.user.name || '' }}</h5>
      @if (userTypeLabel) {
        <span class="user-position">{{ userTypeLabel }}</span>
      }
    </div>
    <app-profile-pic [name]="authService.user.name" />
  </div>

  <oc-dropdown-menu-content #userMenu="ocDropdownMenuContent">
    <oc-dropdown-menu-item (click)="editProfile()">
      <span class="material-symbols-outlined">person</span>
      <!-- Editar perfil -->
      {{ translateService.getTranslation('OTIMUS4417') }}
    </oc-dropdown-menu-item>
    <oc-dropdown-menu-item
      variant="destructive"
      (click)="logout()"
    >
      <span class="material-symbols-outlined">logout</span>
      <!-- Sair -->
      {{ translateService.getTranslation('OTIMUS4418') }}
    </oc-dropdown-menu-item>
  </oc-dropdown-menu-content>
}
